import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fadec4a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fadec4a')) {
      api.createRecord('2fadec4a', component.options)
    } else {
      api.reload('2fadec4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fadec4a&", function () {
      api.rerender('2fadec4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/index.vue"
export default component.exports